<template>
  <div class="all">Coming soon...</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.all{
    padding-top: 100px;
    font-size: 50px;
    color: #409eff;
}
</style>